<template style="background-color:white">
  <section>
    <el-form :model="receiptForm" ref="dataForm" label-position="left" label-width="100px"
      style="width: 90%; margin-left: 5%">
      <el-row>
        <el-col :span="24">
          <el-descriptions :column="2" border>
            <el-descriptions-item label="项目名称">{{
              receiptForm.projectName
              }}</el-descriptions-item>
            <el-descriptions-item label="使用区域" :span="2">{{
              receiptForm.addressName
              }}</el-descriptions-item>
            <el-descriptions-item label="详细地址">
              {{ receiptForm.addressDetail }}
            </el-descriptions-item>
            <el-descriptions-item label="借用日期">{{ receiptForm.borrowDateStart }} 至
              {{ receiptForm.borrowDateEnd }}</el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>
      <div>
        <div style="line-height: 40px; font-size: 14px; text-align: left">
          资产列表
        </div>
        <div>
          <el-table :data="detailListLocal" style="width: 100%; text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="deviceinfo.glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="deviceinfo.zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="deviceinfo.zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="deviceinfo.sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="确认设备" width="80" align="center">
              <template slot-scope="scope">
                <el-button size="mini" style="margin-left: 10px" @click="showRecord(scope.row)"
                  type="text">出库记录</el-button>
              </template>
            </el-table-column>
            <el-table-column label="是否完好" width="160" align="center">
              <template slot-scope="scope">
                <el-radio-group v-model="scope.row.status" size="mini">
                  <el-radio-button label="1" key="1">完好</el-radio-button>
                  <el-radio-button label="0" key="0">有损坏</el-radio-button>
                </el-radio-group>
              </template>
            </el-table-column>
            <el-table-column label="阅读安全交底" width="160">
              <template slot-scope="scope">
                <span v-if="
                  scope.row.deviceinfo.aqjdUrls &&
                  scope.row.deviceinfo.aqjdUrls.length > 0
                ">
                  <span v-if="scope.row.isRead == 0" style="color: chocolate">未阅读</span>
                  <span v-if="scope.row.isRead == 1" style="color: green">已阅读</span>
                  <span>
                    <el-button size="mini" style="margin-left: 10px" @click="
                      readPdf(
                        scope.row.deviceinfo.id,
                        scope.row.deviceinfo.aqjdUrls
                      )
                      " type="primary">阅读</el-button>
                  </span>
                </span>
                <span v-else> 暂无安全交底 </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-form>
    <div style="line-height: 35px; text-align: center; margin-top: 30px">
      <span style="display: block">
        <el-checkbox v-model="checked" @change="readCheck">{{
          tips
          }}</el-checkbox>
      </span>
    </div>
    <div class="dialog-footer" style="margin-top: 30px">
      <el-button style="margin-left: 10px" type="info" @click="$parent.$parent.receiptShow = false">关闭</el-button>
      <el-button style="margin-left: 10px" type="primary" @click="confirmOk()">确认</el-button>
    </div>

    <el-dialog width="1200" top="50px" :visible.sync="pdfShow" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" title="阅读安全交底">
      <ReceiptPdfView :src="pdfPath" :currentDpfId="currentDpfId" @readFinish="readFinish"></ReceiptPdfView>
    </el-dialog>

    <!-- 借还记录 -->
    <el-dialog :visible.sync="lendShow" title="出库记录" width="1000px" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="出库人">{{
          lendForm.outUserText
          }}</el-descriptions-item>
        <el-descriptions-item label="出库时间">{{
          lendForm.outTime
          }}</el-descriptions-item>
        <el-descriptions-item label="出库照片" :span="2" v-if="lendForm.prePhotos">
          <el-image style="height: 100px" :src="getFullUrl(lendForm.prePhotos)"
            :preview-src-list="lendForm.prePhotoUrls"></el-image>
          <span style="margin-left: 10px">共{{
            lendForm.prePhotoUrls ? lendForm.prePhotoUrls.length : 0
          }}张</span>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px" type="info" @click="lendShow = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<!-- 领用确认 -->
<script>
import { updateStatus, mktBorrowViewDetail } from "../../../api/api";
import { base } from "../../../api/api";
import ReceiptPdfView from "./ReceiptPdfView.vue";
export default {
  components: { ReceiptPdfView },
  data() {
    return {
      checked: false,
      pdfShow: false,
      pdfPath: "",
      currentPage: 1,
      tips: "我已阅读安全交底",
      detailListLocal: [],
      currentDpfId: null,
      isFinish: false,
      //显示设备借还记录
      lendShow: false,
      lendForm: {},
    };
  },
  props: {
    receiptForm: { type: Object },
  },
  created() {
    this.detailListLocal = this.receiptForm.detailList;
    this.detailListLocal.forEach((item) => {
      item.isRead = 0;
    });
    this.readFinish(0);
  },
  methods: {
    // 获取完整图片URL
    getFullUrl(path) {
      if (!path) return ''
      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path
      }
      return base + path
    },
    confirmOk() {
      if (!this.checked) {
        this.$message({
          message: "请依次阅读安全交底后确认",
          type: "warning",
        });
      } else {
        this.$confirm("确认提交吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          updateStatus({ id: this.receiptForm.id }).then((res) => {
            if (res.status == 200) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$parent.$parent.receiptShow = false;
              this.$parent.$parent.getList();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        });
      }
    },
    readCheck() {
      if (this.checked && !this.isFinish) {
        this.checked = false;
        this.$message({
          message: "请依次阅读安全交底后确认",
          type: "warning",
        });
      }
    },
    readPdf(deviceId, aqjdUrls) {
      this.pdfPath = aqjdUrls[0].path; //只获取第一个
      this.currentDpfId = deviceId;
      this.pdfShow = true;
    },
    //阅读完成后，子组件回调
    readFinish(deviceId) {
      //设置已阅读
      let count = 0;
      this.detailListLocal.forEach((item) => {
        if (item.deviceinfo.id == deviceId) {
          item.isRead = 1;
        }
        if (
          !item.deviceinfo.aqjdUrls ||
          item.deviceinfo.aqjdUrls.length == 0 ||
          item.isRead == 1
        ) {
          count++;
        }
      });
      if (count == this.detailListLocal.length) {
        this.isFinish = true;
        this.checked = true;
      }
    },
    //查看借还记录
    showRecord(row) {
      this.lendForm = {};
      this.lendShow = true;
      mktBorrowViewDetail(row.id).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          // 处理图片URL数组
          if (data.prePhotoUrls && Array.isArray(data.prePhotoUrls)) {
            data.prePhotoUrls = data.prePhotoUrls.map(url => this.getFullUrl(url))
          }
          if (data.photoUrls && Array.isArray(data.photoUrls)) {
            data.photoUrls = data.photoUrls.map(url => this.getFullUrl(url))
          }
          this.lendForm = data;
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/market/components/ReceiptConfirm.vue